<template>
  <div class="page">

    <div class="title_box">
      <div class="title_box_left" @click="onReport">
        <img src="@/assets/parentImg/体测报告icon.png" width="100%" alt="" >
      </div>
      <div class="title_box_right" @click="onbodyReport">
        <img src="@/assets/parentImg/运动记录icon.png" width="100%" alt="">
      </div>
    </div>

    <div class="sportLogBox">

      <div class="card2 cardBox" >



  <div style="display: flex;align-items: center;justify-content: space-between; font-size: 16px;font-weight: 500;margin-bottom: 20px;">

    <div style="color: #000;width: 35%;" class="dotted-div">数据报告</div>
    <!-- <div style="width: 35%;">
      <van-tabs >
        <van-tab title="周"></van-tab>
        <van-tab title="月"></van-tab>
        <van-tab title="学期"></van-tab>
      </van-tabs>
    </div>
    
    
    <van-popover v-model="showPopover"  trigger="click" :actions="yearList" @select="onSelectPopover">
                  <template #reference>
                    <div class="year_box" >
                    <div>{{ termName }}</div>
                    <div><van-icon name="arrow" :color="active == 0 ? '#000' : '#aaa'" /></div>
                  </div>
                  </template>
        </van-popover> -->


    
  </div>
  <div class="card2_textbox">
  <div><span style="color: #aaa;font-size: 12px;margin-right: 5px;">日均动作次数</span>{{activityBySevenDayData.myNum}}次</div>
  <div><span style="color: #aaa;font-size: 12px;margin-right: 5px;">班级平均</span>{{activityBySevenDayData.classNum}} 次，
    比同龄人略<span>{{ +activityBySevenDayData.myNum >= +activityBySevenDayData.classNum ? '高':'低'}}</span>
  </div>
  <div><span style="color: #aaa;font-size: 12px;margin-right: 5px;">本周主要运动</span>
    <span v-for="(item,index) in activityBySevenDayData.activityAchFitnessList" :key="index">{{ item.projectName||'' }}、</span>
  </div>
  </div>
</div> 

     

   

          <div class="menu"  style="margin-top: 15px;">

<section class="appeal-list-warp" >


     <div class="sportLogBox_top">
    <div style="font-size: 16px;font-weight: 500;" class="dotted-div">运动日历</div>
      
   



      <div class="sportLogBox_top_ul">
        <!-- :style="{ backgroundColor:item.num>0? '#09c1f9':'#ebe5e5' }" -->
        <div class="sportLogBox_top_li" v-for="(item,index) in testTimeQushiNewFitnessList" 
        :style="{ 
        backgroundColor:istoDay(item)&&item.num==0? 'red': item.num>0?'#00ce15':'#d5d9e1',
        color:istoDay(item)&&item.num==0? '#fff': item.num>0?'#fff':'#000',

        

        }"
         >

          {{ weekFile[index] }}
        </div>
      </div>

       <!-- <div class="sportLogBox_top_title_ul">
        <div class="sportLogBox_top_title_li" v-for="(item,index) in testTimeQushiNewFitnessList">
          <div class="grayBox" v-if="+item.num<=0"></div>
          <div class="greenBox" v-if="+item.num>0"></div>
        </div>
      </div> -->
              <!-- <div class="sportLogBox_top_echart">
                <div class="card-eachart" ref="card1"></div>
              </div> -->
          </div>

    <div style="font-size: 16px;font-weight: 500;" class="dotted-div">
      周记录
    </div>
      <div v-if="list.length">
  <van-skeleton title  :loading="loading" style="background-color: #fff;border-radius: 10px;margin: 15px 10px;padding: 15px 10px;">

        <div class="item" v-for="(item, index) of list" :key="index" >

          <div class="item-li">
            <div class="item-li-left">
              <div class="timeline-line"></div>
              <!-- <div style="font-size:16px;font-weight:500;">{{ formatDate(item.testTime, 'DD') }}日</div>
              <div style="color:#B8B8B8;">{{ formatDate(item.testTime, 'MM') }}月</div> -->
              <div style="color:#B8B8B8;font-size: 12px;">{{ formatDate(item.weekTime, 'MM-DD') }}</div>
              <!-- <div style="font-size:15px;font-weight:600;">{{ formatDate(item.weekTime, 'hh:mm') }}</div> -->
              <!-- <div style="font-size:15px;font-weight:600;">{{ formatDate(item.weekTime, 'MM-DD') }}</div> -->
            </div>
            <div style="width: 2%;"></div>
            <!-- props.active ? require('@/assets/icon/运动之星选中.png') :  require('@/assets/icon/运动之星.png') -->
            <div  class="item-li-right"
            :class="['item-li-right', 'item-li-rightb']"
            >
        
              <div  style="height: 100%;">
              <van-row style="height: 100%;">
                  <van-col span="8">

                    <div style="font-weight: 600;">活力值</div>
                     <div  class="mileageStyle" style="color: rgb(46, 139, 211);margin-top: 5px;">{{(+item.testCount*15).toFixed(0) ||0}}
                       <span style="font-size: 14px;font-weight: 500;margin-left: 2px;"> </span> 
                     </div>
                  </van-col>
                  <van-col span="14">
                    <div style="font-weight: 600;">项目</div>

                    <div style="color: rgb(46, 139, 211);margin-top: 5px;">{{ item.projectNames||'暂无项目' }}</div>
                  </van-col>
                  <van-col span="2"  style="color: rgb(46, 139, 211);margin-top: 18px;font-size: 20px;">
                    <!-- <van-icon name="play" /> -->
                  </van-col>
              </van-row>
            </div>
            <!-- <div >
                <div style="font-size:12px;" v-if="+item.status == 0">
                    <van-row>
                  <van-col span="8">
                  </van-col>
                  <van-col span="16">
                    {{SetwarnType[item.warnType]}}
                  </van-col>
              </van-row>
                </div>
            </div> -->
            <!-- <div>
              <van-row class="mileagebox">

                <van-col span="18" >
                  <div  class="mileageStyle" style="color: #3C58C4;">{{item.score||0}}
                    <span style="font-size: 14px;font-weight: 500;margin-left: 5px;">{{ item.projectUnit }} </span> 
                  </div>
                </van-col>
                  <van-col span="5">
                    <span  >
                    </span>
                  </van-col>
                 
              </van-row>
            </div> -->
            </div>
            <div style="width: 3%;"></div>
          </div>
        </div>
</van-skeleton>

      </div>
      <van-empty v-else description="未查询到成绩数据" image-size="100" />
    </section>
</div>
        </div>
    <!-- 弹窗 -->
    <van-dialog 
      v-model="showDialog" 
      title="详情信息" 
      :show-cancel-button="true"
      confirm-button-text="我知道了"
      cancel-button-text="关闭"
      :confirm-button-color="'#2f86f6'"
      class="custom-dialog"
    >
      <div v-if="selectedEvent">
        <p>赛事名称：{{ selectedEvent.title }}</p>
        <p>排名：第{{ selectedEvent.rank }}名</p>
        <p>积分：{{ selectedEvent.points }}分</p>
        <p>参与人数：{{ selectedEvent.participants }}人</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getAllTestBySnCode} from "@/api/integralShop.js";
import { getEduYearList} from "@/api/resultReporting.js";
import moment from 'moment';
import { selectActivityBySevenDay} from "@/api/parentHomePage.js";
import { selectTestTimeQushiNewFitness,selectWeekActivityNewFitness} from "@/api/sportStar.js";

export default {
  data() {
    return {
      loading:false,
      SetValue:{
      0: '不合格',
      1: '合格',
      2: '申诉合格',
      3: '补录合格',
      },
      SetwarnType:{
       1: '步数异常',
      2: '人脸异常',
      3: '拟合度异常',
      },
      weekFile:['周一','周二','周三','周四','周五','周六','周日'],
      termCode:'',
      termName:'',
      yearList:[],
      showPopover:false,
      active:0,
      eachartfilterTabs:0,
      list:[
      ],
      activeTab: 0, // 当前激活的 tab
      showDialog: false, // 控制弹窗显示
      selectedEvent: null, // 当前选中的赛事数据
      events: [
        { rank: 1, points: 100, title: "活力赛", participants: 50, image: require("@/assets/image/Competitionleft1.png"), },
        { rank: 2, points: 25, title: "跳绳赛", participants: 50, image: require("@/assets/image/Competitionleft2.png"), },
        { rank: 3, points: 100, title: "跳跳乐园", participants: 50, image: require("@/assets/image/Competitionleft3.png"), },
        { rank: 4, points: 80, title: "立定跳远", participants: 50, image: require("@/assets/image/Competitionleft4.png"), },
      ],
      activityBySevenDayData:{},
      testTimeQushiNewFitnessList:[]
    };
  },
 async mounted () {
    this.studentTitleInfo = sessionStorage.getItem('studentTitleCard')?JSON.parse(sessionStorage.getItem('studentTitleCard')):{}
   await this.getEduYearList()


  // this.getAllTestBySnCode()
  this.selectActivityBySevenDay()
  this.selectTestTimeQushiNewFitness()
  this.selectWeekActivityNewFitness()
  },
  methods: {
    istoDay(item){
      return moment(item.day).startOf('day').isBefore(moment().startOf('day'))
    },

    selectTestTimeQushiNewFitness(){
      selectTestTimeQushiNewFitness({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
        
      }).then(res=>{
        console.log('selectTestTimeQushiNewFitness',res.data.body);
        this.testTimeQushiNewFitnessList = res.data.body
        // let numData = []
        // let nameData = []
        // res.data.body?.forEach(el=>{
        //   numData.push(el.num)
        //   nameData.push(el.day)
        // })
        // this.$nextTick(() => {
        //   this.getcard1(numData,nameData)
        // })
        
      })
    },
    selectActivityBySevenDay(){
      selectActivityBySevenDay({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
      }).then(res=>{
        this.activityBySevenDayData = res.data.body
        console.log('selectActivityBySevenDay',res);
        
      })
    },
    selectWeekActivityNewFitness(){
      selectWeekActivityNewFitness({
        termCode:this.termCode,
        snCode:this.studentTitleInfo.snCode,
        schoolCode:this.studentTitleInfo.schoolCode,
      }).then(res=>{
        console.log(res);
        
          this.list = res.data.body

      })
    },
     onReport(){
      let data = JSON.stringify({...this.studentTitleInfo, })
      this.$router.push({path:'fitnessReport',query:{data:data}})
  },
  onbodyReport(){
      let data = JSON.stringify({...this.studentTitleInfo,})
      this.$router.push({path:'bodyForging',query:{data:data}})
  },
           // 查询学年
 async getEduYearList(){
  console.log(this.studentTitleInfo,123);
  
 await getEduYearList({
            snCode:this.studentTitleInfo.snCode,
            schoolCode:this.studentTitleInfo.schoolCode,
          }).then(res=>{  
            res.data.data?.forEach(el=>{
                  el.text = el.name
              if(+el.isActive==1){
                  this.termCode = el.code
                  this.termName = el.name
              }
            })
            this.yearList = res.data.data
          })
 },
    // 切换学年
    onSelectPopover(action){
        console.log(action);
         this.termCode = action.code
         this.termName = action.name
      },
    getAllTestBySnCode(){
      this.loading =true
          getAllTestBySnCode({
              snCode:this.studentTitleInfo.snCode,
              schoolCode:this.studentTitleInfo.schoolCode,
            }).then(res=>{
              console.log(res);
        this.loading =false
           
              this.list = (res.data.body || []).slice(0, 100);
            })
      },
     formatDate(datestr = new Date(), formart = 'yyyy年MM月DD日') {
    return moment(datestr).format(formart);
},
    // 显示详情弹窗
    showDetails(event) {
      this.selectedEvent = event; // 设置选中的赛事数据
      this.showDialog = true; // 打开弹窗
    },
    getcard1 (numData,nameData) {


      console.log('this.$refs.card1',this.$refs.card1);
      
      const myChart = echarts.init(this.$refs.card1)
      const option = {
  color: ['#FF0087',],
  title: {
    text: '本周趋势',
    show: true,
    textStyle: {
      fontSize: 16,
      fontWeight: '500',
      color: '#333'
    },
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  legend: {
    data: ['本周趋势']
  },
 
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: false,
      data: nameData
      // ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
    }
  ],
  yAxis: [
    {
      type: 'value',
      // min: 0,         // 最小值
      // max: 1000,      // 最大值（可省略自动计算）
      splitNumber: 4, // 分几段（可选）
    }
  ],
  series: [
  // {
  //     name: '体锻',
  //     type: 'line',
  //     stack: 'Total',
  //     label: {
  //       show: true,
  //       position: 'top',
  //       borderColor: '#fff',
  //     },
  //     itemStyle: {
  //       color: '#DFE7E0', // 圆点颜色
  //       borderColor: '#DFE7E0', // 圆点边框色
  //       borderWidth: 2
  //     },
  //     // lineStyle:{
  //     //   width: 1,
  //     //   color: '#DFE7E0'
  //     // },
  //     areaStyle: {
  //       opacity: 0.8,
  //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
  //         {
  //           offset: 0,
  //           color: '#87C7D4'
  //         },
  //         {
  //           offset: 1,
  //           color: '#DFE7E0'
  //         }
  //       ])
  //     },
  //     emphasis: {
  //       focus: 'series'
  //     },
  //     data: [820, 932, 901, 934, 1290, 1330, 1320]
  //   },
    {
      type: 'line',
      stack: 'Total',
      smooth: true,
      lineStyle: {
        width: 0
      },
      label: {
        show: true,
        position: 'top',
        borderColor: '#fff',
      },
      itemStyle: {
        color: '#00c0fa', // 圆点颜色
        borderColor: '#00c0fa', // 圆点边框色
        borderWidth: 2
      },
      areaStyle: {
        opacity: 0.8,
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: '#015eea'
          },
          {
            offset: 1,
            color: '#00c0fa'
          }
        ])
      },
      emphasis: {
        focus: 'series'
      },
      data: numData
      // [220, 302, 181, 234, 210, 0, 0]
    }
  ]
};

      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }

      window.addEventListener('resize', myChart.resize)
    },
  },
};
</script>

<style lang="less" scoped>
@header-footer--line-height: 40px;
.page {
  // background: #f7f8fa;
  // min-height: 100vh;
  padding: 4vw;  // 移除顶部内边距
  height: 100%;
  overflow: scroll;

  // background-image: url('../../assets/background/homeBG.png')!important;
	// background-repeat: no-repeat;
	// background-size: 100% 100%;
}
  .title_greenBox{
        display: inline-block;
        width: 5px;
        height: 5px;
        background-color: #09c1f9;
        border-radius: 50%;
        // margin: auto;
  }
.dotted-div {
  position: relative;
  padding-left: 15px; /* 为圆点留出空间 */
}
.dotted-div::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background-color: #09c1f9;
  border-radius: 50%; /* 关键：创建圆形 */
}
.title_box{
  display: flex;
  justify-content: space-between;
  margin-bottom: 2vw;
  .title_box_left{
    width: 45%;
  }
  .title_box_right{
    width: 45%;
    
  }
}
// Tab样式优化
:deep(.van-tabs) {



  
  .van-tab {
    font-size: 14px; // 保持字体大小
    font-weight: 500;
    color: #666; // 更柔和的默认字体颜色
    // padding: 0 12px; // 调整内边距
    // min-width: 100px; // 增加最小宽度
    text-align: center;
    
    &--active {
      color: #2b7af6; // 更鲜明的激活状态颜色
      font-weight: 500;
    }
  }

  .van-tabs__line {
    background-color: #1956ca;
    box-shadow: -0.244px -1.985px 3.92px 0.08px rgba(9, 255, 229, 0.72),inset 0px 1px 1px 0px rgba(34, 34, 34, 0.83);
    // height: 3px;
    // border-radius: 3px;
    // position: absolute;
    // bottom: -2px; // 调整位置
    // margin-top: 8px; // 增加与文字的间距
  }
}

// 内容区域样式优化
.tab-content {
  padding: 10px; // 增加内边距
  // background: #f5f7fa; // 更柔和的背景颜色
}
.sportLogBox{
  border-radius: 15px;
  .sportLogBox_top{
   border-radius: 15px;
    position: relative;
    height: 125px;
    background-color: #fff;
    .sportLogBox_top_title_ul{
      display: flex;
      align-content: center;
      justify-content: space-between;
      text-align: center;
      margin: 20px 0;
    }
    .sportLogBox_top_title_li{
      width: 14%;
      text-align: center;
      .grayBox{
        width: 5px;
        height: 5px;
        background-color: #d5d9e1;
        border-radius: 50%;
        margin: 0 auto;
      }
      .greenBox{
         width: 8px;
        height: 8px;
        background-color: #09c1f9;
        border-radius: 50%;
        margin: 0 auto;
      }
    }

    .sportLogBox_top_ul{
      display: flex;
      align-content: center;
      justify-content: space-between;
      text-align: center;
      margin: 20px 0;
    }
    .sportLogBox_top_li{
      width: 14%;
      font-size: 11px;
      width: 36px;
      height: 36px;
      line-height: 35px;
      text-align: center;
      border-radius: 50%;
      color: #fff;
      // background-color: #ebe5e5;
      

    }

    .sportLogBox_eachartfilter{
      position: absolute;
      top: 5px;
      right: 40px;
      width: 115px;
      z-index: 2;
      ::v-deep .van-tabs__nav{
        background-color: transparent;
      }
      ::v-deep  .van-tabs__line{
          width: 20px;
        }
        ::v-deep  .van-tabs__nav--line{
          padding-bottom: 8px;
        }
    }
    .sportLogBox_top_echart{
      // background-color: #ecfbff;
      border-radius: 10px;
      height: 200px;
      // padding: 10px;
      .card-eachart{
        height: 200px;
        width: 100%;

      }
    }
    .sportLogBox_top_bottom{
      display: flex;
      justify-content: space-around;
      margin-top: 8px;
    }
  }
}
.cardBox{
  background-color: #fff;
  height: 15em;
  // margin: 10px ;
  padding: 4vw;
  border-radius: 15px;

  // border-radius: 10px;
  // box-shadow: 0px 1px 6px 0px #eef1fc;
}
.year_box{
  display: flex;
  justify-content: space-around;
  border: 1px solid #aaa;
  height: 28px;
  line-height: 28px;
  width: 80px;
  border-radius: 6px;
  text-align: right;
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  


}
.card2_textbox{
  // border-left: 3px solid #10afee;
  // border-radius: 10px;

  line-height: 30px;
  font-size: 14px;
 
}
.sportLogBox_eachartfilterTabs{
    border-radius: 10px;

    ::v-deep .van-tabs__nav{
        background-color: #e6e0e083;
  }
  ::v-deep .van-tabs__wrap{
    border-radius: 10px;
    height: 32px;
  }
  }
 .card2{
  padding: 4vw;
  height: 9em;
  ::v-deep  .van-tabs__line{
    width: 20px;
    background-color: #1956ca;
    box-shadow: -0.244px -1.985px 3.92px 0.08px rgba(9, 255, 229, 0.72),inset 0px 1px 1px 0px rgba(34, 34, 34, 0.83);
  }
}
.menu{
  font-size: 13px;
  .menu_down{
    text-align: center;
    margin: 10px;


 .center{
        height: 118px;
        line-height: 118px;
        text-align: center;
        position: relative;
        // background-color: #fff;
        // border-radius:10px;
        margin-top: 16px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        object-fit: cover;
        .center_text{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            font-size: 20px;
            font-weight: 700;
            color: #458ff1b9;
        }
        .center_value{
            color: #bbb;
        }
    }


  }
 .menu_row{
    text-align: center;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-items: center;
   text-align: center;
   
   .menu_li{
    margin: 10px auto;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
   }

 } 

}
.appeal-list {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  &-warp {
    // flex: 1;
    border-radius: 15px;

    padding: 4vw;
    background-color: #fff;
    // border-radius: 10px;
    // margin: 10px;
  .mileagebox{
      display: flex;
      align-items: baseline;
      margin-top: 10px;
    }
    .mileageStyle{
      width: 100%;
      font-size: 32px;
      font-family: DINPro-Bold;
      overflow: hidden;
      white-space: nowrap;      /* 不换行 */
      // font-weight: 700;
      letter-spacing: 1px;

    }
    .item {
      margin-top: 15px;

  .item-li{
    display: flex;

    .item-li-left{
      // position: relative;
      // width: 20%;
      // text-align: center;
      // margin: auto;

      position: relative;
  width: 20%;
  text-align: center;
  margin: auto;
  min-height: 60px; /* 根据实际高度调整 */
    }
    .timeline-line {
      position: absolute;
      left: 50%;
      top: 45px;
      width: 1px;
      height: 80%;
      background: #e0e0e079;
      transform: translateX(-50%);
      z-index: 0;
    }
    .item-li-right{
      // background: linear-gradient(147deg, #DAFF8D 0%, #DAFF8D 100%);
      // background: #fff;
      // box-shadow: 0px 1px 6px 0px #eef1fc;
      border-radius: 10px;
      padding: 12px;
      width: 70%;
      display: flex;
      flex-direction: column;
      position: relative;
      .item-li-right-goal{
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 16px;
        font-weight: 500;
        font-family: DINPro-Regular;
      }
    }
    .item-li-righta{
      background-image: url('../../assets/background/indexli.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      color: #fff;
    }
    .item-li-rightb{
      // background-image: url('../../assets/background/indexliv2.png');
      // background-size: 100% 100%;
      // background-repeat: no-repeat;


  //     border-radius: 40rpx;
  // background-color: rgb(246, 246, 246);
  // box-shadow: inset 0.07px 1.999px 3px 0px rgba(162, 162, 162, 0.67);
  // width: 828rpx;
  // height: 260rpx;

  background-color: rgb(239, 250, 255);
  border-radius: 15px;
  width: 68.5vw;
  height: 60px;



    }
  }


      .right {
          font-size: 16px;
          font-weight: 500;
        
          &.bg0 {
            // background: #ffecde;
            color: #ff5600;
          }
          &.bg1 {
            // background: #e4f2ff;
            color: #007ff0;
          }
          &.bg2 {
            // background: #e4f2ff;
            color: #007ff0;
          }
          &.bg3 {
            // background: #ffe9eb;
            color: #ff0000;
          }
        }
    }
  }
  .footer {
    display: flex;
    margin-bottom: 3%;
    margin-top: 5%;
    justify-content: space-around;
    /deep/.van-button {
        
      flex-basis: 80%;
    }
  }
}
.event-card {
  display: flex; // 改为横向布局
  background: #ffffff;
  margin-bottom: 10px; // 增加间距
  padding: 10px; // 调整内边距
  border-radius: 10px; // 更圆润的圆角
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06); // 更柔和的阴影
  transition: all 0.3s ease;
  border: 1px solid #e6e6e6; // 更柔和的边框颜色
  
  &:first-child {
    margin-top: 0;
  }
  
  &:active {
    transform: scale(0.96); // 更明显的缩放效果
    opacity: 0.95; // 调整透明度
  }

  .event-image {
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
    margin-right: 16px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .event-info {
    flex: 1;
    display: flex;
    flex-direction: column;

    .event-header {
      display: flex;
      align-items: center;
      justify-content: space-between; // 调整为两端对齐
      margin-bottom: 8px; // 调整间距

      .rank {
        font-size: 16px; // 调整字体大小
        font-weight: 500; // 加粗字体
        color: #444; // 调整颜色为稍深
        line-height: 1.2; // 调整行高
      }

      .points {
        font-size: 18px; // 调整字体大小
        font-weight: 700; // 加粗字体
        color: #ff4500; // 调整颜色为更鲜明
        font-family: DIN;
        line-height: 1.2; // 调整行高
      }
    }

    .event-title {
      font-size: 14px; // 调整字体大小
      font-weight: 500;
      color: #222; // 调整颜色为更深
      margin: 8px 0; // 调整上下间距
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 1.4; // 调整行高

      .van-icon {
        color: #aaa; // 更柔和的图标颜色
      }
    }

    .event-footer {
      font-size: 12px; // 调整字体大小
      color: #555; // 调整颜色为稍深
      display: flex;
      align-items: center;
      line-height: 1.4; // 调整行高

      span {
        &::before {
          content: '';
          display: inline-block;
          width: 6px; // 调整圆点大小
          height: 6px;
          // background: #ccc; // 更柔和的圆点颜色
          border-radius: 50%;
          margin-right: 10px; // 调整间距
          vertical-align: middle;
        }
      }
    }
  }
}

// 弹窗样式优化
:deep(.custom-dialog) {
  .van-dialog__header {
    padding: 20px 24px; // 调整内边距
    font-size: 16px;
    font-weight: 500;
    color: #333; // 更深的标题颜色
    border-bottom: 1px solid #e6e6e6; // 更柔和的边框颜色
  }

  .van-dialog__content {
    padding: 28px; // 增加内边距
    max-height: 60vh; // 调整最大高度
    overflow-y: auto;

    p {
      margin: 20px 0; // 调整上下间距
      color: #333; // 调整颜色为更深
      font-size: 14px;
      line-height: 1.6; // 调整行高
      display: flex;
      justify-content: space-between;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .van-dialog__footer {
    border-top: 1px solid #e6e6e6; // 更柔和的边框颜色
    padding: 12px 24px; // 调整内边距
    
    .van-dialog__cancel {
      color: #888; // 更柔和的取消按钮颜色
      font-size: 14px;
    }
    
    .van-dialog__confirm {
      font-size: 14px;
      font-weight: 500;
    }

    .van-button {
      height: 40px; // 调整按钮高度
      border-radius: 20px; // 调整圆角
      
      &--default {
        border-color: #ddd; // 更柔和的边框颜色
      }
    }
  }
}

.van-empty {
  padding: 36px 0; // 调整内边距
  
  &__image {
    width: 140px; // 调整图片大小
    height: 140px;
  }

  &__description {
    color: #666; // 调整颜色为稍深
    font-size: 14px;
    margin-top: 24px; // 调整上下间距
    line-height: 1.4; // 调整行高
  }
}
</style>